import Backbone from 'backbone'
import template from './two-column-details-test.hbs'
import TestGardener from '../../tests/scoreboard/components/test-gardener'
import TwoColumnDetailsForm from 'scoreboard/components/two-column-details-form'
import mobile from 'scoreboard/components/mobile'
import scrollContainer from 'scoreboard/components/scroll-container'
import projects from 'scoreboard/projects/projects'
import appDisplay from 'scoreboard/components/app-display'
import dialogTemplate from './two-column-details-dialog-test.hbs'
const blurb = `For a number of years now, work has been proceeding in order to bring perfection to the crudely conceived idea of a transmission that would not only supply inverse reactive current for use in unilateral phase detractors, but would also be capable of automatically synchronizing cardinal grammeters. Such an instrument is the turbo encabulator. Now basically the only new principle involved is that instead of power being generated by the relative motion of conductors and fluxes, it is produced by the modial interaction of magneto-reluctance and capacitive diractance. The original machine had a base plate of pre-famulated amulite surmounted by a malleable logarithmic casing in such a way that the two spurving bearings were in a direct line with the panametric fan. The latter consisted simply of six hydrocoptic marzlevanes, so fitted to the ambifacient lunar waneshaft that side fumbling was effectively prevented. The main winding was of the normal lotus-o-delta type placed in panendermic semi-boloid slots of the stator, every seventh conductor being connected by a non-reversible tremie pipe to the differential girdle spring on the “up” end of the grammeters. The turbo-encabulator has now reached a high level of development, and it’s being successfully used in the operation of novertrunnions. Moreover, whenever a forescent skor motion is required, it may also be employed in conjunction with a drawn reciprocation dingle arm, to reduce sinusoidal repleneration. For a number of years now, work has been proceeding in order to bring perfection to the crudely conceived idea of a transmission that would not only supply inverse reactive current for use in unilateral phase detractors, but would also be capable of automatically synchronizing cardinal grammeters. Such an instrument is the turbo encabulator. Now basically the only new principle involved is that instead of power being generated by the relative motion of conductors and fluxes, it is produced by the modial interaction of magneto-reluctance and capacitive diractance. The original machine had a base plate of pre-famulated amulite surmounted by a malleable logarithmic casing in such a way that the two spurving bearings were in a direct line with the panametric fan. The latter consisted simply of six hydrocoptic marzlevanes, so fitted to the ambifacient lunar waneshaft that side fumbling was effectively prevented. The main winding was of the normal lotus-o-delta type placed in panendermic semi-boloid slots of the stator, every seventh conductor being connected by a non-reversible tremie pipe to the differential girdle spring on the “up” end of the grammeters. The turbo-encabulator has now reached a high level of development, and it’s being successfully used in the operation of novertrunnions. Moreover, whenever a forescent skor motion is required, it may also be employed in conjunction with a drawn reciprocation dingle arm, to reduce sinusoidal repleneration.`

const TwoColumnDetailsFormDialog = Backbone.View.extend({
	className: 'two-column-details-form two-column-details-form-dialog-test',

	events: {
		'click .show-banner': 'showBanner',
		'click .show-error-banner': 'showErrorBanner',
		'click .show-bottom-panel': 'showBottomPanel'
	},

	initialize: function() {
		let projectId = projects.selectedOrFirstId()
		this.gardener = new TestGardener({
			showProjectSelector: true,
			projectId,
			descendants:true,
			ordered:true,
			permissions: true,
			finderOptions: {
				type: 'light'
			},
			streamOptions: {
				projectId
			}
		})
	},

	render: function() {
		this.$el.append(dialogTemplate({blurb}))
		this.$('.left-panel .panel-content .tree-container').append(this.gardener.render().el)
		this.gardener.show().startStream()
		this._setupTwoColumnDetailsForm()
		return this
	},

	_setupTwoColumnDetailsForm: function() {
		this.twoColumnsDetailsForm = new TwoColumnDetailsForm({
			el: this.el,
			gardener: this.gardener,
			getScrollContainer: () => this.$('.dialog-body'),
			isDialog: true
		})
	},

	showBanner: function() {
		this.$('.standard-banner').toggleClass('is-not-displayed')
		this.twoColumnsDetailsForm.resize()
	},

	showErrorBanner: function() {
		// .is-not-displayed class used to correctly calculate banner spacing in
		// two-column-details-form.js. .error-banner needs an extra display
		// setting in order to override it's display: none styling during testing
		// since it isn't inside a form marked as errored.
		if (this.$('.error-banner').hasClass('is-not-displayed')) {
			this.$('.error-banner')
				.removeClass('is-not-displayed')
				.css('display', 'block')
		} else {
			this.$('.error-banner')
				.addClass('is-not-displayed')
				.css('display', '')
		}

		this.twoColumnsDetailsForm.resize()
	},

	showBottomPanel: function() {
		this.$('.bottom-panel').toggleClass('is-not-displayed')
		this.twoColumnsDetailsForm.resize()
	}
})

const TwoColumnDetailsTestView = Backbone.View.extend({
	className: 'admin table-hack display-layout admin-test-view admin-test-two-column two-column-details-form',

	events: {
		'click .show-dialog': 'showDialog',
		'click .show-footer': 'showFooter'
	},

	initialize: function() {
		let projectId = projects.selectedOrFirstId()
		this.gardener = new TestGardener({
			showProjectSelector: true,
			projectId,
			descendants:true,
			ordered:true,
			permissions: true,
			finderOptions: {
				type: 'light'
			},
			streamOptions: {
				projectId
			}
		})
	},

	render: function () {
		this.$el.empty().append(template({blurb}))
		this.$('.left-column .tree-container').append(this.gardener.render().el)
		this.gardener.show().startStream()
		this._setupTwoColumnDetailsForm()
		return this
	},

	_setupTwoColumnDetailsForm: function() {
		this.twoColumnsDetailsForm = new TwoColumnDetailsForm({
			el: this.el,
			gardener: this.gardener,
			getScrollContainer: () => {
				if (mobile.isMobileWidth()) {
					return this.$el
				} else {
					return scrollContainer(this.el)
				}
			}
		})
	},

	showDialog: function() {
		appDisplay.dialog(new TwoColumnDetailsFormDialog())
	},

	showFooter: function() {
		this.$('footer').toggleClass('is-not-displayed')
		this.twoColumnsDetailsForm.resize()
	}
})

export default TwoColumnDetailsTestView
